// Core
import { createActions } from 'redux-actions';

export const compareActions = createActions({
    ADD_TO_COMPARE:         (hotelId, offerId) => ({ hotelId, offerId }),
    ADD_TO_COMPARE_SUCCESS: () => void 0,
    ADD_TO_COMPARE_FAIL:    (error) => error,

    REMOVE_FROM_COMPARE:         (offerId) => offerId,
    REMOVE_FROM_COMPARE_SUCCESS: () => void 0,
    REMOVE_FROM_COMPARE_FAIL:    (error) => error,

    LOAD_LOCAL_COMPARED:         () => void 0,
    LOAD_LOCAL_COMPARED_SUCCESS: (compared) => compared,
    LOAD_LOCAL_COMPARED_FAIL:    (error) => error,
});
